export default __webpack_public_path__ + "static/media/commands-icon.b492cef0.svg";